<template>
  <ValidationObserver v-slot="{ invalid }">
    <div class="card">
      <div class="card-header d-flex justify-content-between">
        <h3 class="card-title">{{ title }}</h3>

        <div class="d-flex gap-2">
          <button
              v-if="!viewMode"
              class="btn btn-outline-secondary"
              @click="cancel"
          >
            Annuler
          </button>

          <button
              v-if="!viewMode"
              class="btn btn-success"
              :disabled="invalid || saving"
              @click="save"
          >
            {{ submitLabel }}
          </button>

          <button
              v-if="viewMode && canEdit"
              class="btn btn-primary"
              @click="goEdit"
          >
            Modifier
          </button>

          <button
              v-if="viewMode && canDelete"
              class="btn btn-danger"
              @click="remove"
          >
            Supprimer
          </button>
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <FieldViewEdit
                label="Code"
                v-model="form.code"
                rules="required|min:1|max:5"
                :viewMode="viewMode"
                :disabled="editMode"
                required
            />
          </div>

          <div class="col-md-6">
            <FieldViewEdit
                label="Libellé"
                v-model="form.label"
                rules="required|min:3"
                :viewMode="viewMode"
            />
          </div>

          <div class="col-md-12">
            <FieldViewEdit
                label="Description"
                type="textarea"
                v-model="form.description"
                :viewMode="viewMode"
            />
          </div>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
  import FieldViewEdit from "@/components/forms/FieldViewEdit.vue";
  import {Operations, Roles} from "../../../../helpers/roles";
  import {confirmAction} from "../../../../helpers/helpers";
  import {API} from "../../../../helpers/api-endpoints";

  export default {
    name: 'MarketCategoryForm',
    components: { FieldViewEdit },
    props: {
      createMode: Boolean,
      editMode: Boolean,
      viewMode: Boolean
    },
    data() {
      return {
        saving: false,
        operations: [],
        form: {
          code: '',
          label: '',
          description: ''
        }
      };
    },
    computed: {
      title() {
        if (this.viewMode) return 'Détail de la catégorie de marché';
        if (this.editMode) return 'Modifier la catégorie de marché';
        return 'Créer une catégorie de marché';
      },
      submitLabel() {
        return this.editMode ? 'Mettre à jour' : 'Créer';
      },
      canEdit() {
        return this.operations.includes(Operations.EDIT)
            && this.$can(Roles.MARKET_CATEGORY_EDIT);
      },
      canDelete() {
        return this.operations.includes(Operations.DELETE)
            && this.$can(Roles.MARKET_CATEGORY_DELETE);
      }
    },
    async mounted() {
      if (!this.createMode) {
        await this.load();
      }
    },
    methods: {
      async load() {
        const { code } = this.$route.params;
        const { data } = await this.$http.get(
            API.MARKET_CATEGORY_GET(code)
        );
        this.form = {
          code: data.code,
          label: data.label,
          description: data.description
        };
        this.operations = data.operations || [];
      },

      async save() {
        const { confirmed } = await confirmAction(
            this.editMode ? 'edit' : 'create'
        );
        if (!confirmed) return;

        this.saving = true;
        try {
          if (this.editMode) {
            await this.$http.put(
                API.MARKET_CATEGORY_UPDATE(this.form.code),
                this.form
            );
          } else {
            await this.$http.post(
                API.MARKET_CATEGORY_CREATE,
                this.form
            );
          }
          this.$router.push({ name: 'adminMarketCategories' });
        } finally {
          this.saving = false;
        }
      },

      async remove() {
        const { confirmed } = await confirmAction('delete');
        if (!confirmed) return;

        await this.$http.delete(
            API.MARKET_CATEGORY_DELETE(this.form.code)
        );
        this.$router.push({ name: 'adminMarketCategories' });
      },

      cancel() {
        this.$router.push({ name: 'adminMarketCategories' });
      },

      goEdit() {
        this.$router.push({
          name: 'adminMarketCategoryEdit',
          params: { code: this.form.code }
        });
      }
    }
  };
</script>
